function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "13",
  height: "20",
  viewBox: "0 0 13 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M11.636 2.76A1.255 1.255 0 109.861.988l-8.13 8.138a1.237 1.237 0 000 1.75l8.14 8.14a1.251 1.251 0 101.77-1.77L4.396 10l7.24-7.24z",
  fill: "#ABAEB5"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.423.55a1.873 1.873 0 112.65 2.648L5.272 10l6.807 6.807a1.87 1.87 0 11-2.645 2.645l-8.14-8.14a1.856 1.856 0 010-2.624L9.423.55zm1.774.872a.636.636 0 00-.898.002l-8.13 8.139a.619.619 0 000 .874l8.14 8.14a.633.633 0 10.894-.895L3.521 10 11.2 2.323a.636.636 0 00-.002-.9z",
  fill: "#ABAEB5"
})));